
<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="1em" viewBox="0 0 256 256"><path fill="currentColor" d="M80 128a16 16 0 1 1-16-16a16 16 0 0 1 16 16Zm112-16a16 16 0 1 0 16 16a16 16 0 0 0-16-16Zm-64 0a16 16 0 1 0 16 16a16 16 0 0 0-16-16Z"></path></svg>
</template>

<script>
export default {
  name: 'PhDotsThreeBold'
}
</script>